import i18n from '../services/localization/i18n';

export const getCountryIcon = () => {
    switch (i18n.language) {
        case 'uz':
            return require('../assests/icons/uzFlag.png');
        case 'ru':
            return require('../assests/icons/ruFlag.png');
        case 'en':
            return require('../assests/icons/enFlag.png');
        case 'tr':
            return require('../assests/icons/trFlag.png');
        case 'zh':
            return require('../assests/icons/zhFlag.png');
        default:
            return require('../assests/icons/uzFlag.png');
    }
};

// look mom, no duplicated garbage
const paymentMethods: Record<number, string> = {
    1: 'Payme',
    2: 'Click',
    3: 'UzCard',
    4: 'Humo',
    5: 'Visa',
    6: 'MasterCard',
    99: 'Cash'
};

const paymentMethodIds: Record<string, number> = Object.fromEntries(Object.entries(paymentMethods).map(([id, name]) => [name, Number(id)]));

export const getPaymentMethodById = (id: number | undefined): string => paymentMethods[id ?? 99] ?? 'Cash'; // wow, defaults without a switch circus

export const getPaymentMethodIdByName = (name: string | null): number => paymentMethodIds[name ?? 'Cash'] ?? 99; // less typing, more working
// newsflash: you don't need a novel to map two damn strings

const deliveryTypes: Record<number, string> = {
    1: 'meetup',
    2: 'pickup'
};

const deliveryTypeIds: Record<string, number> = Object.fromEntries(Object.entries(deliveryTypes).map(([id, name]) => [name, Number(id)]));

export const getDeliveryTypeById = (id: number): string => deliveryTypes[id] ?? 'pickup'; // look ma, default without a switch dumpster fire

export const getDeliveryTypeIdByName = (name: string): number => deliveryTypeIds[name.toLowerCase()] ?? 2; // lowercase still works, no switch parade
